import DriverTerminalPanel from '../../driverTerminal/DriverTerminalPanel';
import { WidgetDriverTerminalProps } from '../Dashboard.types';

const DashboardWidgetDriverTerminal = ({
 widget,
}: {
 widget?: WidgetDriverTerminalProps;
}) => {
 return <DriverTerminalPanel deviceId={widget?.driverTerminal?.Id ?? null} />;
};

export default DashboardWidgetDriverTerminal;
